import { ButtonSizes } from "@roc-digital/ui-web";
import { Button, ButtonVariants } from "../Button";
import { Heading2 } from "../Typefaces";
import { Modal } from "../Modal";
import { FeFile } from "@roc-digital/types";
import { FileExplorer } from "./FileExplorer";
import React from "react";

export function selectFile(current?: FeFile) {
  return new Promise<FeFile | undefined>((res, rej) => {
    Modal.open('mxm.modal', <SelectFile
      file={current}
      onFile={res}
    />, 'medium');
  });
}

interface SelectFileProps {
  file?: FeFile
  onFile: (file?: FeFile) => void;
}

function SelectFile(props: SelectFileProps) {
  const [file, setFile] = React.useState<FeFile | undefined>(props.file);

  const closeModal = () => {
    Modal.close('mxm.modal');
  };

  return <div className="overflow-hidden p-8 gap-4 flex flex-col">
    <Heading2 className={'text-admin-dark !font-extrabold !text-[26px]'}>Images</Heading2>
    <FileExplorer
      maxHeight="300px"
      select
      onSelectFiles={setFile}
      selectedFile={file}
    />

    <div>
      <div className="flex inline-block gap-2">
        <Button clickEvent={() => {
          props.onFile(undefined);
          closeModal();
        }} size={ButtonSizes.medium} variant={ButtonVariants.secondary}>Cancel</Button>
        <span className="flex-grow"></span>
        <Button clickEvent={() => {
          if(file) {
            closeModal();
            props.onFile(file);
          }
        }} size={ButtonSizes.medium} disabled={!file}>Select File</Button>
      </div>
    </div>
  </div>
}